import { useState, useEffect, useRef, useMemo } from "react";
import "./index.css";
import { toast_position } from "../../../../redux/features/Settings/Authorization";
import { toast } from "react-toastify";
import {
  addItemizedStatementDescription,
  downloadAllItemisizedReport,
  getAllOwnerItemisizedReport,
  ownerListViewAllAcc,
  resetItemisedData,
  setOwnerAllAccItemisedLoading,
  updateItemizedStatementData,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import CommonCalendar from "../../../../components/_utils/CommonCalendar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";

import IfscCodeMapper from "../../../../components/_utils/IfscLogoMapper";
import OwnerAccountPopUp from "../../OwnerAccountPopUp";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import Loader from "../../../../components/Loader/Index";
import DualIconRoundButton from "../../../../components/_utils/CommonButtons/DualIconRoundButton";
import IconRoundButton from "../../../../components/_utils/CommonButtons/IconRoundButton";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import PrimaryWithIconButton from "../../../../components/_utils/CommonButtons/PrimaryWithIconButton";
import CommonDownloadFileWithDropdown from "../../../_utils/CommonDownloadFileWithDropdown";
import PrimaryRightIconFill from "../../../_utils/CommonButtons/PrimaryRightIconFill";
import SVGComponent from "../../../_utils/SVGComponent";
import AmountRangeDropdown from "../../../_utils/CommonDropdown/AmountRangeDropdown";
import Chips from "../../../_utils/CommonButtons/Chips";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import SmallPopupWithInput from "../../../_utils/CommonSmallPopupWithInput";
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import CommonToast from "../../../_utils/CommonToast";
import UniversalRefreshToast from "../../../_utils/UniversalRefreshToast";
import ICONS from "../../../../assets/Icons";

const ItemisedReportComponent = (props) => {
  const amtDivRef = useRef(null);
  const services = useSelector((state) => state.refreshToken.services);

  const navigate = useNavigate();
  const scrollTopRef = useRef(null);
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const [showOwnerPopup, setShowOwnerPopup] = useState(false);
  const [showAmtFilterDiv, setShowAmtFilterDiv] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAmtFilterApplied, setIsAmtFilterApplied] = useState(false);
  const [isDateConfirm, setIsDateConfirm] = useState(false);
  const {
    ownerAllAccItemisedData,
    ownerAllAccItemisedLoading,
    ownerItemizedAddDescriptionLoading,
  } = useSelector((state) => state.ownerAllVerification);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showDescriptionPopup, setShowDescriptionPopup] = useState(false);
  const [description, setDescription] = useState("");
  const [currentDescription, setCurrentDescription] = useState({});
  const [isEditDescription, setIsEditDescription] = useState(false);

  const scrollRef = useRef(null);
  const [filterOpen, setFilterOpen] = useState(false);
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);

  const calenderRef = useRef(null);
  const calenderButtonRef = useRef(null);
  const additionalDetailsRef = useRef(null);
  const additionalDetailsBtnRef = useRef(null);
  const filterButtonRef = useRef(null);
  const selectAccountRef = useRef(null);
  const [pageSize, setPageSize] = useState(dropdownOptions[0]);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const dispatch = useDispatch();
  const filterRef = useRef(null);
  const filterapplyButtonRef = useRef(null);
  const addtionalapplyButtonRef = useRef(null);
  const calenderapplyButtonRef = useRef(null);
  const [selectedtBankState, setSelectedtBankState] = useState("");
  const [selectedtBank, setSelectedtBank] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [amountLimitState, setAmountLimitState] = useState({
    min: "",
    max: "",
  });
  const [amountLimit, setAmountLimit] = useState({
    min: "",
    max: "",
  });

  const [accountnumberstate, setaccountnumberstate] = useState(
    props?.popType == "ownerStatement" ? [props?.ownerDetailId] : [],
  );
  const [accountNumber, setAccountNumber] = useState(
    props?.popType == "ownerStatement" ? [props?.ownerDetailId] : [],
  );
  const [accountDefaultNumber, setDefaultAccountNumber] = useState(
    props?.popType == "ownerStatement" ? [props?.ownerDetailId] : [],
  );
  const [selectedType, setSelectedType] = useState("XLSX");

  const [startDateState, setStartDateState] = useState(
    new Date(new Date().setDate(1)),
  );
  const [startDate, setStartDate] = useState(new Date(new Date().setDate(1)));
  const [endDateState, setEndDateState] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const columnMapper = {
    owner_bank_account_number: "owner_bank_account_number",
    IFSC_Code: "ifsc_code",
    Bank: "bank_name",
    Name: "name",
    Party_name: "party_name",
    Party_IFSC: "party_ifsc",
    Party_account_number: "party_account_number",
    Transaction_date: "transaction_date",
    Value_date: "value_date",
    Narration: "narration",
    Amount: "amount",
    Bank_reference: "bank_reference",
    Type: "credit_debit",
    Description: "description",
  };

  const defaultAdditionalDetailCol = [
    { colName: "Bank", colWidth: "column-width-sm", flex: 0 },
    {
      colName: "Transaction date",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Value date",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Party name",
      colWidth: "column-width-lg",
      flex: 1,
    },
    { colName: "Amount", colWidth: "column-width-md", flex: 0 },
    {
      colName: "Narration",
      colWidth: "column-width-lg",
      flex: 1,
    },
    {
      colName: "Bank reference",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Party account number",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Party IFSC",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Description",
      colWidth: "column-width-lg",
      flex: 1,
    },
  ];
  const [additionalDetailCol, setAdditionalDetailsCol] = useState(
    defaultAdditionalDetailCol,
  );

  const [additionalDetailColState, setAdditionalDetailsColState] = useState(
    defaultAdditionalDetailCol,
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await dispatch(ownerListViewAllAcc({}));
      } catch (error) {}
    };

    fetchData();

    return () => {
      dispatch(resetItemisedData());
    };
  }, []);
  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(date.getTime() / 1000);

    return timestamp;
  };
  const handleFetch = () => {
    dispatch(
      getAllOwnerItemisizedReport({
        id: accountNumber,
        start_date: convertDate(startDate),
        end_date: convertDate(endDate),
        page_no: currentPage,
        start_amount: isAmtFilterApplied ? amountLimit.min : "",
        end_amount: isAmtFilterApplied ? amountLimit.max : "",
        page_size: pageSize,
        bank_name: selectedtBank.length ? selectedtBank : undefined,
      }),
    );
  };
  useEffect(() => {
    if (accountNumber.length) {
      handleFetch();
    } else {
      dispatch(setOwnerAllAccItemisedLoading(false));
    }
  }, [
    currentPage,
    pageSize,
    accountNumber,
    selectedtBank,
    amountLimit,
    startDate,
    endDate,
  ]);

  const handleApplyEnable = () => {
    if (
      accountDefaultNumber.length &&
      accountnumberstate.length &&
      !accountNumber.length
    ) {
      return true;
    }
    if (
      accountDefaultNumber.length === accountnumberstate.length &&
      accountDefaultNumber.every((ac) => {
        return accountnumberstate.includes(ac);
      }) &&
      accountDefaultNumber.length === accountNumber.length &&
      accountDefaultNumber.every((ac) => {
        return accountNumber.includes(ac);
      }) &&
      !selectedtBank.length &&
      !amountLimit.min.length &&
      !amountLimit.max.length &&
      !selectedtBankState.length &&
      !isAmtFilterApplied
    ) {
      return false;
    }
    return true;
  };

  const handleAddDetailaApplyEnable = () => {
    return (
      JSON.stringify(defaultAdditionalDetailCol.map((x) => x.colName)) !=
        JSON.stringify(additionalDetailColState.map((x) => x.colName)) ||
      JSON.stringify(defaultAdditionalDetailCol.map((x) => x.colName)) !=
        JSON.stringify(additionalDetailCol.map((x) => x.colName))
    );
  };

  const downloadStatement = async () => {
    UniversalRefreshToast("Downloading statement.");
    setIsDisabled(true);
    try {
      const response = await dispatch(
        downloadAllItemisizedReport({
          id: accountNumber,
          start_date: convertDate(startDate),
          end_date: convertDate(endDate),
          start_amount: isAmtFilterApplied ? amountLimit.min : "",
          end_amount: isAmtFilterApplied ? amountLimit.max : "",
          page_size: pageSize,
          formatType: selectedType.toLowerCase(),
          bank_name: selectedtBank.length ? selectedtBank : undefined,
          filter_columns: additionalDetailCol.map(
            (itm) => columnMapper[itm.colName.replaceAll(" ", "_")],
          ),
        }),
      );
      toast.dismiss();
      CommonToast({
        text: "Statement downloaded successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      setIsDisabled(false);
    } catch (error) {
      toast.dismiss();
      CommonToast({
        text: "Failed to download statement.",
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setIsDisabled(false);
      console.error(error);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
    }
    if (filterOpen) {
      if (event.key === "Enter" && !showAmtFilterDiv && handleApplyEnable()) {
        filterapplyButtonRef.current.click();
      }
    }
    if (showCalendar) {
      if (
        event.key === "Enter" ||
        (isDateConfirm && startDateState && endDateState)
      ) {
        calenderapplyButtonRef.current.click();
      }
    }
    if (showAdditionalDetails) {
      if (event.key === "Enter" && handleAddDetailaApplyEnable()) {
        addtionalapplyButtonRef.current.click();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    filterOpen,
    showCalendar,
    showAdditionalDetails,
    showAmtFilterDiv,
    handleAddDetailaApplyEnable,
    handleApplyEnable,
  ]);

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDateState(start);
    setEndDateState(end);
    setIsDateConfirm(!!(start && end));
  };

  const move = () => {
    scrollRef?.current?.scrollTo({ left: 0, behavior: "smooth" });
    setTimeout(() => {
      scrollTopRef?.current?.scrollTo({ top: 0, behavior: "smooth" });
    }, 500);
  };

  const handleSelect = (value) => {
    setCurrentPage(1);
    setSelectedValue(value);
    setPageSize(value);
  };

  const handlePagination = (page) => {
    if (scrollRef?.current) {
      scrollRef.current.scrollLeft = GlobalConfiguration.lengthCheckZero;
    }
    setCurrentPage(page);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        (additionalDetailsRef.current &&
          additionalDetailsRef.current.contains(e.target)) ||
        (additionalDetailsBtnRef.current &&
          additionalDetailsBtnRef.current.contains(e.target))
      ) {
      } else {
        setShowAdditionalDetails(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [additionalDetailsRef]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        (filterRef.current && filterRef.current.contains(e.target)) ||
        (filterButtonRef.current &&
          filterButtonRef.current.contains(e.target)) ||
        (selectAccountRef.current &&
          selectAccountRef.current.contains(e.target))
      ) {
      } else {
        setFilterOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [filterRef]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        (calenderRef.current && calenderRef.current.contains(e.target)) ||
        (calenderButtonRef.current &&
          calenderButtonRef.current.contains(e.target))
      ) {
      } else {
        setShowCalendar(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [calenderRef]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (amtDivRef.current && amtDivRef.current.contains(e.target)) {
      } else {
        setShowAmtFilterDiv(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [amtDivRef]);

  const handleAddDetail = (name) => {
    if (!additionalDetailColState.some((x) => x.colName === name)) {
      let data = {
        colName: name,
        colWidth: defaultAdditionalDetailCol.find((x) => x.colName === name)
          .colWidth,
        flex: defaultAdditionalDetailCol.find((x) => x.colName === name).flex,
      };
      let arr = [...additionalDetailColState, data].sort(
        (a, b) =>
          defaultAdditionalDetailCol.map((x) => x.colName).indexOf(a.colName) -
          defaultAdditionalDetailCol.map((x) => x.colName).indexOf(b.colName),
      );
      setAdditionalDetailsColState(arr);
    } else {
      if (additionalDetailColState.length === 1) {
        return CommonToast({
          text: "Atleast one column is required",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      setAdditionalDetailsColState(
        additionalDetailColState
          .filter((itm) => {
            return name !== itm.colName;
          })
          .sort(
            (a, b) =>
              defaultAdditionalDetailCol
                .map((x) => x.colName)
                .indexOf(a.colName) -
              defaultAdditionalDetailCol
                .map((x) => x.colName)
                .indexOf(b.colName),
          ),
      );
    }
  };

  const formatDateandTime = (
    input,
    showtime = false,
    hour = false,
    showminutes = false,
    showmeridian = false,
    readable = false,
  ) => {
    let date;

    if (input instanceof Date) {
      date = input;
    } else if (typeof input === "number" || /^\d+$/.test(input)) {
      const ts = Number(input);
      date = new Date(ts < 1e12 ? ts * 1000 : ts);
    } else if (typeof input === "string") {
      date = new Date(input);
    } else {
      return "-";
    }

    if (isNaN(date.getTime())) return "-";

    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes();

    const ampm = hours >= 12 ? "pm" : "am";
    const displayHour = hours % 12 || 12;

    const pad = (n) => (n < 10 ? `0${n}` : n);

    // ---------- DATE PART ----------
    const datePart = readable
      ? `${day} ${date.toLocaleString("default", { month: "short" })} ${year}`
      : `${day}-${month + 1}-${year}`;

    if (!showtime) return datePart;

    // ---------- TIME PART ----------
    let timeParts = [];

    if (hour) timeParts.push(pad(displayHour));
    if (showminutes) timeParts.push(pad(minutes));

    let timePart = timeParts.join(":");

    if (showmeridian && timePart) {
      timePart += ` ${ampm}`;
    }

    return timePart ? `${datePart}, ${timePart}` : datePart;
  };

  const formatDate = (date) => {
    return `${date.getDate()} ${date.toLocaleString("default", {
      month: "short",
    })}, ${date.getFullYear()}`;
  };

  const filterCategory = () => {
    move();
    setCurrentPage(1);
    setStartDate(startDateState);
    setEndDate(endDateState);
    setShowCalendar(false);
  };

  const handleAmtFilterApply = () => {
    if (Object.values(amountLimitState).includes("")) return;
    setIsAmtFilterApplied(true);
    setTimeout(() => {
      setShowAmtFilterDiv(false);
    }, 500);
  };

  const handleClearAmts = () => {
    setAmountLimitState((prev) => ({
      ...prev,
      min: "",
      max: "",
    }));
    setIsAmtFilterApplied(false);
  };

  const handleAmtInput = (e) => {
    const { name, value } = e.target;
    if (value[0] != 0) {
      const sanitizedText = value
        .replace(/[^0-9.]/g, "")
        .replace(/(\..*)\./g, "$1");
      const amount = parseFloat(sanitizedText);
      if (sanitizedText.length !== "" && !isNaN(amount)) {
        if (value.includes(".") && value.length > 12) return;
        if (!value.includes(".") && value.length > 9) return;
        const regex = /^\d*\.?\d{0,2}$/;

        if (regex.test(value)) {
          setIsAmtFilterApplied(false);
          setAmountLimitState((prevState) => ({
            ...prevState,
            [name]: sanitizedText,
          }));
        }
      } else {
        setIsAmtFilterApplied(false);
        setAmountLimitState((prevState) => ({
          ...prevState,
          [name]: "",
        }));
      }
    }
  };

  const handleKey = (event) => {
    if (showAmtFilterDiv) {
      if (event.key === "Enter" && showAmtFilterDiv && isAmtFilterApplied) {
        handleAmtFilterApply();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("keydown", handleKey);
    };
  }, [isAmtFilterApplied, showAmtFilterDiv]);

  const handleEnterKey = (e) => {
    if (
      amountLimitState.min !== "" &&
      amountLimitState.max !== "" &&
      Number(amountLimitState.max) >= Number(amountLimitState.min) &&
      e.key === "Enter"
    ) {
      handleAmtFilterApply();
    }
  };

  const renderHeader = useMemo(() => {
    return (
      <div
        className="flex Total_Value_Responsives"
        style={{
          position: "relative",
        }}
      >
        <div
          className=" py-padding-md px-padding-sm cursor-pointer flex Qsmd:hidden"
          onClick={() => {
            if (props?.popType == "ownerStatement") {
              props?.setViewItemisedOpenPop(false);
            } else {
              navigate(-1);
            }
          }}
        >
          <SVGComponent
            url={
              "https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg"
            }
            color="var(--text-primary)"
            height={"var(--icon-sm)"}
            width={"var(--icon-sm)"}
          />
        </div>
        <div className="flex flex-col gap-gap-xs">
          <p className="text-font-sm text-text-primary">
            Total entries : {ownerAllAccItemisedData?.total_count || 0}
          </p>
          <p className="text-font-xxs text-text-secondary  ">
            As on {formatDateandTime(new Date(), true, true, true, true, true)}{" "}
            - Live activity statement update as per bank
          </p>
        </div>
      </div>
    );
  }, [ownerAllAccItemisedData]);

  return (
    <>
      {showDescriptionPopup && (
        <div
          style={{ zIndex: "var(--z-index-modal)" }}
          className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center bg-opacity-dark-opacity"
        >
          <SmallPopupWithInput
            headerTitle="Description"
            headerFontColor="text-primary"
            headerFontWeight="semibold"
            textSize="font-md"
            subtext="Provide custom description for easier tracking and reconciliation"
            inputIsFullWidth={true}
            inputBgColor="var(--primary-bg)"
            inputPlaceholder="Enter description (upto 150 char)"
            inputFgColor={
              description?.length
                ? "var(--text-primary)"
                : "var(--text-secondary)"
            }
            inputValue={description}
            inputFontKind="medium"
            inputOnInput={(e) => {
              if (
                e.target.value?.replace(/\s+/g, " ").trimStart()?.length <=
                GlobalConfiguration.inputMaxLength
              )
                setDescription(
                  e.target.value?.replace(/\s+/g, " ").trimStart(),
                );
            }}
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneHandleFunction={() => {
              if (!ownerItemizedAddDescriptionLoading) {
                setShowDescriptionPopup(false);
                setDescription("");
                setCurrentDescription({});
              }
            }}
            btnOneEnabledBgColor="transparent"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={ownerItemizedAddDescriptionLoading}
            btnOneHoverOption="white"
            btnTwoText={
              currentDescription?.description?.length ? "Confirm" : "Add"
            }
            btnTwoBtnType="button"
            btnTwoHandleFunction={async () => {
              if (!ownerItemizedAddDescriptionLoading) {
                let response = await dispatch(
                  addItemizedStatementDescription({
                    id: currentDescription.acc_id,
                    statement_entry_id:
                      currentDescription.ecollection_callback_id,
                    description: description,
                  }),
                );
                if (response?.payload?.status)
                  dispatch(
                    updateItemizedStatementData({
                      description: description,
                      ecollection_callback_id:
                        currentDescription.ecollection_callback_id,
                    }),
                  );
                setCurrentDescription({});
                setIsEditDescription(false);
                setShowDescriptionPopup(false);
                setDescription("");
              }
            }}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              (!isEditDescription && !description?.length) ||
              description === currentDescription?.description
            }
            btnTwoIsLoading={ownerItemizedAddDescriptionLoading}
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}
      {showOwnerPopup && (
        <div
          style={{ zIndex: "var(--z-index-modal)" }}
          className="fixed top-top-base left-left-base w-width-full h-height-full bg-Primary-black bg-opacity-light-opacity"
        >
          <OwnerAccountPopUp
            setIsSidebarOpen={filterOpen}
            setOpenOwner={() => {
              setaccountnumberstate(accountNumber);
              setShowOwnerPopup(false);
            }}
            onClosed={() => setShowOwnerPopup(false)}
            accountNumber={accountNumber}
            setAccountNumber={setAccountNumber}
            accountnumberstate={accountnumberstate}
            setaccountnumberstate={setaccountnumberstate}
            multiSelect={true}
            setDefaultAccountNumber={setDefaultAccountNumber}
            accountDefaultNumber={accountDefaultNumber}
            flow={"txnViewAll"}
            popType={"ownerStatement"}
          />
        </div>
      )}
      {
        <div
          style={{
            display:
              !ownerAllAccItemisedData?.ecollection_callbacks?.length && "none",
            background: !ownerAllAccItemisedData?.ecollection_callbacks?.length
              ? "var(--primary-bg)"
              : "var(--primary-nav)",
            zIndex:
              showCalendar || filterOpen || showAdditionalDetails
                ? "var(--z-index-base)"
                : "var(--z-index-fixed-ui)",
            width:
              props?.popType == "ownerStatement"
                ? "var(--popup-width)"
                : "var(--width-full)",
            bottom:
              props?.popType == "ownerStatement"
                ? "var(--bottom-sm)"
                : "var(--bottom-base)",
            borderRadius:
              props?.popType == "ownerStatement"
                ? " var(--border-radius-md)"
                : "none",
          }}
          className={`fixed w-width-full ${
            props?.popType == "ownerStatement"
              ? "ownerdetailsresponsivestatement"
              : ""
          }`}
        >
          <PaginationComponent
            handleSelect={handleSelect}
            selectedValue={selectedValue}
            data={ownerAllAccItemisedData || []}
            pageSize={pageSize}
            dropdownOptions={dropdownOptions}
            handlePagination={handlePagination}
            currentPage={currentPage}
            setIsOpen={setIsOpen}
            typePopup={props?.popType == "ownerStatement" ? true : false}
          />
        </div>
      }

      <div
        className={` bg-custom-appBack flex flex-col overflow-hidden ${props?.popType == "ownerStatement" ? " flex-1" : "h-full-height"}`}
        style={{ overflow: filterOpen && "hidden" }}
      >
        <div
          className={`hidden ${props?.popType == "ownerStatement" ? "hidden" : "Qsmd:block"} `}
          style={{
            minHeight:
              props?.popType == "ownerStatement"
                ? "var(--navbar-height)"
                : "var(--navbar-breadcrumb-height)",
            backgroundColor: "var(--primary-nav)",
            zIndex: "var(--z-index-header)",
          }}
        ></div>
        <div
          className={`${
            props?.popType == "ownerStatement"
              ? "itemised-owner_div_container-popup"
              : "itemised-owner_div_container"
          }`}
        >
          <div className={"itemised-owner_div"}>
            <div className=" flex flex-wrap Qsmd:justify-between w-width-full gap-y-gap-sm">
              {renderHeader}

              <div className="gap-gap-sm gap-y-gap-sm flex flex-wrap Qsmd:justify-between items-center relative">
                <IconRoundButton
                  enabledBgColor="var(--primary-bg)"
                  isLoading={false}
                  handleFunction={() => {
                    move();
                    handleFetch();
                  }}
                  hoverOption="white"
                  icon={
                    "https://q2pay.in/new_assets/common/view_all/reload_refresh_white.svg"
                  }
                  title="Refresh live activity"
                  isDisabled={
                    showAdditionalDetails || filterOpen || showCalendar
                  }
                />
                <DualIconRoundButton
                  icon={
                    "https://q2pay.in/new_assets/common/view_all/calender.svg"
                  }
                  imgColor={"var(--primary-bg)"}
                  arrowIconDown={
                    "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                  }
                  arrowIconUP={
                    "https://q2pay.in/new_assets/common/arrows/arrow_up_white.svg"
                  }
                  arrowIconUPColor="var(--primary-bg)"
                  arrowIconDownColor="var(--primary-bg)"
                  handleFunction={(e) => {
                    e.preventDefault();
                    if (!showAdditionalDetails && !filterOpen)
                      setShowCalendar(!showCalendar);
                  }}
                  isLoading={false}
                  isOpen={showCalendar}
                  isDisabled={showAdditionalDetails || filterOpen}
                  enabledBgColor={"var(--text-primary)"}
                  disabledBgColor={"var(--text-primary)"}
                  buttonRef={calenderButtonRef}
                  title="Open Calendar"
                />
                <DualIconRoundButton
                  icon={
                    "https://q2pay.in/new_assets/common/view_all/additional_fields_white.svg"
                  }
                  imgColor={"var(--primary-bg)"}
                  arrowIconDown={
                    "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                  }
                  arrowIconUP={
                    "https://q2pay.in/new_assets/common/arrows/arrow_up_white.svg"
                  }
                  arrowIconUPColor="var(--primary-bg)"
                  arrowIconDownColor="var(--primary-bg)"
                  handleFunction={(e) => {
                    e.preventDefault();
                    if (
                      !showCalendar &&
                      !filterOpen &&
                      accountDefaultNumber.length
                    ) {
                      setShowAdditionalDetails(!showAdditionalDetails); // Toggle visibility
                    }
                  }}
                  isLoading={false}
                  isOpen={showAdditionalDetails}
                  isDisabled={
                    showCalendar || filterOpen || !accountDefaultNumber.length
                  }
                  enabledBgColor={"var(--text-primary)"}
                  disabledBgColor={"var(--text-primary)"}
                  buttonRef={additionalDetailsBtnRef}
                  title="Additional Fields"
                />
                <DualIconRoundButton
                  icon={
                    "https://q2pay.in/new_assets/common/view_all/filter.svg"
                  }
                  imgColor={
                    accountNumber.length ||
                    selectedtBank.length ||
                    (amountLimit.max.length && amountLimit.max.length)
                      ? "var(--primary-bg)"
                      : "var(--text-primary)"
                  }
                  arrowIconDown={
                    "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                  }
                  arrowIconDownColor={
                    accountNumber.length ||
                    selectedtBank.length ||
                    (amountLimit.max.length && amountLimit.max.length)
                      ? "var(--primary-bg)"
                      : "var(--text-primary)"
                  }
                  arrowIconUP={
                    "https://q2pay.in/new_assets/common/arrows/arrow_up_white.svg"
                  }
                  arrowIconUPColor={
                    (filterOpen && accountNumber.length) ||
                    selectedtBank.length ||
                    (amountLimit.max.length && amountLimit.max.length)
                      ? "var(--primary-bg)"
                      : "var(--text-primary)"
                  }
                  handleFunction={(e) => {
                    e.preventDefault();
                    if (
                      !showAdditionalDetails &&
                      !showCalendar &&
                      accountDefaultNumber.length
                    ) {
                      setFilterOpen(!filterOpen);
                    }
                  }}
                  isLoading={false}
                  isOpen={filterOpen}
                  isDisabled={
                    showAdditionalDetails ||
                    showCalendar ||
                    !accountDefaultNumber.length
                  }
                  enabledBgColor={"var(--text-primary)"}
                  disabledBgColor={
                    accountNumber.length ||
                    selectedtBank.length ||
                    (amountLimit.max.length && amountLimit.max.length)
                      ? "var(--text-primary)"
                      : "var(--primary-bg)"
                  }
                  buttonRef={filterButtonRef}
                  title="Filters"
                />
                <CommonDownloadFileWithDropdown
                  btnText="Download statement"
                  dropdownOptions={["XLSX", "CSV", "TSV", "PDF"]}
                  icon={
                    "https://q2pay.in/new_assets/common/view_all/download_statement.svg"
                  }
                  isDisabled={
                    isDisabled ||
                    showAdditionalDetails ||
                    filterOpen ||
                    showCalendar ||
                    !ownerAllAccItemisedData?.ecollection_callbacks?.length
                  }
                  handleFunction={(e) => {
                    if (
                      isDisabled ||
                      showAdditionalDetails ||
                      filterOpen ||
                      showCalendar ||
                      !ownerAllAccItemisedData?.ecollection_callbacks?.length
                    ) {
                      e.stopPropagation();
                      return;
                    } else {
                      downloadStatement();
                    }
                  }}
                  selectedOption={selectedType}
                  setSelectedOption={setSelectedType}
                />
              </div>
            </div>
          </div>
          <div
            className={`px-top-base Qmd:px-padding-xl itemised-filter-transition-${filterOpen ? "open" : "close"}`}
          >
            {filterOpen && (
              <div
                className="itemised-filter-div"
                ref={filterRef}
              >
                <div>
                  <span className="text-text-primary text-font-sm font-normal">
                    Filter{" "}
                  </span>
                  <div className="itemised-owner_filterdropdown gap-y-gap-sm Qsmd:gap-x-gap-md">
                    <div
                      className="w-width-full Qsmd:w-width-md"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "var(--gap-md)",
                        height: "fit-content",
                      }}
                    >
                      <div style={{ position: "relative" }}>
                        <p
                          style={{
                            color: "var(--text-secondary)",
                            fontSize: "var(--font-xs)",
                            marginBottom: "var(--margin-xs)",
                          }}
                        >
                          Account
                        </p>
                        <div
                          onClick={() => {
                            if (props?.popType != "ownerStatement") {
                              setShowOwnerPopup(true);
                            }
                          }}
                          className=" w-width-full  Qsmd:w-width-full bg-primary-nav-act rounded-border-radius-md"
                          style={{
                            height: "fit-content",
                            opacity:
                              props?.popType == "ownerStatement"
                                ? "var(--light-opacity)"
                                : "var(--base-opacity)",
                            cursor:
                              props?.popType == "ownerStatement"
                                ? "default"
                                : "pointer",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              color: "var(--text-primary)",
                              padding: "var(--padding-sm) var(--padding-md)",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "var(--font-xs)",
                              }}
                            >
                              {props?.popType == "ownerStatement"
                                ? formatAccountNumber(
                                    props?.ownerDetailData?.bank_acc_no,
                                  )
                                : accountnumberstate.length
                                  ? `${accountnumberstate.length} selected`
                                  : "Select accounts"}
                            </span>

                            <SVGComponent
                              url={
                                "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                              }
                              color="var(--text-primary)"
                              height={"var(--icon-xs)"}
                              width={"var(--icon-xs)"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="itemised-border-mid-div"></div>
                    <div
                      className="w-width-full Qsmd:w-width-md  Qsmd:pl-padding-base"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "var(--gap-md)",
                        height: "fit-content",
                      }}
                    >
                      <div className="flex flex-col">
                        <p
                          style={{
                            color: "var(--text-secondary)",
                            fontSize: "var(--font-xs)",
                            marginBottom: "var(--margin-xs)",
                          }}
                        >
                          Amount
                        </p>
                        <AmountRangeDropdown
                          placeholder="Set range"
                          type="small"
                          range={amountLimitState}
                          setRange={setAmountLimitState}
                          onOpen={() => setShowAmtFilterDiv(true)}
                          onClose={() => setShowAmtFilterDiv(false)}
                          onApply={(range) => {
                            setIsAmtFilterApplied(true);
                          }}
                          onClear={() => {
                            handleClearAmts();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="py-padding-md mb-margin-xl pb-padding-xl Qsmd:mb-margin-base Qsmd:pb-padding-md rounded-tl-border-radius-md  rounded-tr-border-radius-md px-padding-sm mt-margin-md Qsmd:mt-margin-base Qsmd:px-padding-base  items-center justify-end  relative bottom-bottom-base w-width-full  Qsmd:h-0 Qsmd:bg-transparent "
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div className="itemised-buttoncontainer">
                    <PrimaryButton
                      isDisabled={!handleApplyEnable()}
                      enabledBgColor=""
                      btnText="Default"
                      outLineColor="var(--text-primary)"
                      enabledTextColor="var(--text-primary)"
                      handleFunction={() => {
                        if (handleApplyEnable()) {
                          move();
                          setAccountNumber(accountDefaultNumber);
                          setaccountnumberstate(accountDefaultNumber);
                          setSelectedtBank("");
                          setSelectedtBankState("");
                          setAmountLimit({ min: "", max: "" });
                          setAmountLimitState({ min: "", max: "" });

                          setIsAmtFilterApplied(false);
                          setCurrentPage(1);
                        }
                      }}
                      hoverOption="white"
                    />

                    <PrimaryButton
                      inActiveVariantNeeded={true}
                      isDisabled={!handleApplyEnable()}
                      enabledBgColor="var(--text-primary)"
                      disabledBgColor="var(--text-disabled)"
                      btnText="Apply"
                      disabledTextColor="var(--text-primary)"
                      enabledTextColor="var(--primary-bg)"
                      handleFunction={() => {
                        if (handleApplyEnable()) {
                          move();
                          setAccountNumber(accountnumberstate);
                          setSelectedtBank(selectedtBankState);
                          if (
                            isAmtFilterApplied &&
                            amountLimitState.min !== "" &&
                            amountLimitState.max !== "" &&
                            Number(amountLimitState.max) >
                              Number(amountLimitState.min)
                          ) {
                            setAmountLimit(amountLimitState);
                          } else if (
                            !amountLimitState.min.length ||
                            !amountLimitState.max.length
                          ) {
                            setAmountLimit(amountLimitState);
                          }

                          setCurrentPage(1);
                          setFilterOpen(false);
                        }
                      }}
                      hoverOption="black"
                      buttonRef={filterapplyButtonRef}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          <div
            ref={calenderRef}
            className={`itemised-filter-transition-${showCalendar ? "open" : "close"}`}
          >
            <div
              className="itemised-beneTxnviewallFilterDiv flex gap-y-gap-md"
              style={{
                visibility: showCalendar ? "visible" : "hidden",
                borderTop: "var(--border) solid var(--primary-bg)",
              }}
            >
              <div className="itemised-beneTxnFilterSection1 flex flex-col gap-y-gap-md">
                <p className="text-text-primary text-font-sm font-normal">
                  Calender{" "}
                </p>
                <div className="itemised-beneTxnFilterSection3">
                  <span
                    style={{
                      color: "var(--text-primary)",
                      width: "var(--width-full)",
                      height: "fit-content",
                      fontSize: "var(--font-xs)",
                      fontWeight: "var(--font-normal)",
                      marginBottom: "var(--margin-sm)",
                    }}
                  >
                    Date range
                  </span>
                  <div className="flex flex-1">
                    <CommonCalendar
                      startDate={startDateState}
                      endDate={endDateState}
                      handleDateChange={handleDateChange}
                      type="small"
                      selectionType="range"
                    />
                  </div>
                </div>
              </div>
              <div
                className="pb-padding-xl mb-margin-xl pt-top_lg Qsmd:mb-margin-base Qsmd:pb-padding-md rounded-tl-border-radius-md  rounded-tr-border-radius-md px-padding-sm mt-margin-lg Qsmd:mt-margin-base Qsmd:px-padding-base  items-center justify-end  relative bottom-bottom-base w-width-full  Qsmd:h-0 Qsmd:bg-transparent "
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div className="itemised-buttoncontainer">
                  <PrimaryButton
                    isDisabled={
                      !(
                        (+startDate !== +startDateState &&
                          +endDate !== +endDateState) ||
                        !startDate ||
                        !endDate ||
                        isDateConfirm
                      )
                    }
                    enabledBgColor=""
                    btnText="Default"
                    outLineColor="var(--text-primary)"
                    enabledTextColor="var(--text-primary)"
                    handleFunction={() => {
                      if (
                        (+startDate !== +startDateState &&
                          +endDate !== +endDateState) ||
                        !startDate ||
                        !endDate ||
                        isDateConfirm
                      ) {
                        move();
                        setStartDate(new Date(new Date().setDate(1)));
                        setStartDateState(new Date(new Date().setDate(1)));
                        setEndDate(new Date());
                        setEndDateState(new Date());
                        setIsDateConfirm(false);
                      }
                    }}
                    hoverOption="white"
                  />

                  <PrimaryButton
                    inActiveVariantNeeded={true}
                    isDisabled={
                      !(isDateConfirm && startDateState && endDateState)
                    }
                    enabledBgColor="var(--text-primary)"
                    btnText="Apply"
                    disabledBgColor="var(--text-disabled)"
                    disabledTextColor="var(--text-primary)"
                    enabledTextColor="var(--primary-bg)"
                    handleFunction={() => {
                      if (isDateConfirm && startDateState && endDateState) {
                        filterCategory();
                      }
                    }}
                    hoverOption="black"
                    buttonRef={calenderapplyButtonRef}
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            ref={additionalDetailsRef}
            className={`itemised-filter-transition-${showAdditionalDetails ? "open" : "close"}`}
          >
            <div
              className="itemised-beneTxnviewallFilterDiv h-full-height Qsmd:h-auto flex justify-start  Qsmd:justify-between"
              style={{
                visibility: showAdditionalDetails ? "visible" : "hidden",
                borderTop: "var(--border) solid var(--primary-bg)",
              }}
            >
              <div className=" pb-padding-md Qsmd:pb-padding-base itemised-addtional-div Qsmd:h-auto px-padding-md Qsmd:px-padding-base flex flex-col">
                <span className="text-text-primary text-font-sm font-normal">
                  Live activity fields
                </span>
                <div className=" flex Qsmd:flex-row flex-col justify-between text-font-xs text-text-secondary gap-y-gap-sm Qsmd:gap-gap-md py-padding-md">
                  <div className="flex flex-col gap-gap-md w-width-full Qsmd:w-width-sm">
                    <PrimaryRightIconFill
                      btnText="Bank"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Bank");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Bank",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Bank",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Bank",
                        )
                          ? "black"
                          : "white"
                      }
                    />

                    <PrimaryRightIconFill
                      btnText="Amount"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Amount");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Amount",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Amount",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Amount",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                    <PrimaryRightIconFill
                      btnText="Party IFSC"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Party IFSC");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Party IFSC",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Party IFSC",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Party IFSC",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                  </div>
                  <div className="itemised-border-mid-div"></div>
                  <div className="flex flex-col gap-gap-md  w-width-full Qsmd:w-width-sm">
                    <PrimaryRightIconFill
                      btnText="Transaction date"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Transaction date");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Transaction date",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Transaction date",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Transaction date",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                    <PrimaryRightIconFill
                      btnText="Narration"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Narration");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Narration",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Narration",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Narration",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                    <PrimaryRightIconFill
                      btnText="Description"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Description");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Description",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Description",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Description",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                  </div>
                  <div className="itemised-border-mid-div"></div>
                  <div className="flex flex-col gap-gap-md w-width-full Qsmd:w-width-sm">
                    <PrimaryRightIconFill
                      btnText="Value date"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Value date");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Value date",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Value date",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Value date",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                    <PrimaryRightIconFill
                      btnText="Bank reference"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Bank reference");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Bank reference",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Bank reference",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Bank reference",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                  </div>
                  <div className="itemised-border-mid-div"></div>
                  <div className="flex flex-col gap-gap-md w-width-full Qsmd:w-width-sm">
                    <PrimaryRightIconFill
                      btnText="Party name"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Party name");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Party name",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Party name",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Party name",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                    <PrimaryRightIconFill
                      btnText="Party account number"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Party account number");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Party account number",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Party account number",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Party account number",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                  </div>
                </div>
              </div>
              <div
                className="py-padding-md mb-margin-xl pb-padding-xl Qsmd:mb-margin-base Qsmd:pb-padding-md rounded-tl-border-radius-md  rounded-tr-border-radius-md px-padding-sm mt-margin-base Qsmd:mt-margin-base Qsmd:px-padding-base  items-center justify-end relative bottom-bottom-base w-width-full  Qsmd:h-0 Qsmd:bg-transparent "
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div className="itemised-buttoncontainer">
                  <PrimaryButton
                    isDisabled={!handleAddDetailaApplyEnable()}
                    enabledBgColor=""
                    btnText="Default"
                    outLineColor="var(--text-primary)"
                    enabledTextColor="var(--text-primary)"
                    handleFunction={() => {
                      if (handleAddDetailaApplyEnable()) {
                        move();
                        setAdditionalDetailsColState(
                          defaultAdditionalDetailCol,
                        );
                        setAdditionalDetailsCol(defaultAdditionalDetailCol);
                      }
                    }}
                    hoverOption="white"
                  />

                  <PrimaryButton
                    inActiveVariantNeeded={true}
                    isDisabled={!handleAddDetailaApplyEnable()}
                    enabledBgColor="var(--text-primary)"
                    btnText="Apply"
                    disabledBgColor="var(--text-disabled)"
                    disabledTextColor="var(--text-primary)"
                    enabledTextColor="var(--primary-bg)"
                    handleFunction={() => {
                      if (handleAddDetailaApplyEnable()) {
                        move();
                        setAdditionalDetailsCol(additionalDetailColState);
                        setShowAdditionalDetails(false);
                      }
                    }}
                    hoverOption="black"
                    buttonRef={addtionalapplyButtonRef}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`${
            props?.popType == "ownerStatement"
              ? "itemised-filter_applied_div_owner_detail"
              : ""
          } itemised-filter_applied_div w-width-full`}
        >
          <div
            style={{
              borderTop: "var(--border) solid var(--primary-bg)",
            }}
            className={` Qsmd:w-max-content-width mx-auto py-padding-sm flex justify-between items-center  Qsmd:relative ${
              showCalendar || showAdditionalDetails || filterOpen
                ? ""
                : "z-z-index-content"
            } Qsmd:z-z-index-base Qsmd:mt-top-base overflow-x-auto Qsmd:overscroll-none bg-primary-nav Qsmd:bg-transparent`}
          >
            <div className="flex w-full-width">
              <div className="filter_badge_div itemised-filter_badge_div_responsive items-center">
                <p className="font-normal text-font-sm text-text-primary ">
                  Filtered by :
                </p>

                {startDate && endDate && (
                  <Chips
                    txtChip={`${formatDate(startDate)} - ${formatDate(endDate)}`}
                    icon={
                      "https://q2pay.in/new_assets/common/view_all/close_with_blue_circle.svg"
                    }
                    enabledBgColor=""
                    outLineColor="var(--primary-act)"
                    disableIcon={true}
                    handleFunction={(e) => {
                      e.stopPropagation();
                      return;
                    }}
                    enabledTextColor="var(--text-primary)"
                  />
                )}
                {accountNumber.length > 0 ? (
                  <Chips
                    txtChip={
                      props?.popType == "ownerStatement"
                        ? formatAccountNumber(
                            props?.ownerDetailData?.bank_acc_no,
                          )
                        : `${accountNumber.length} ${
                            accountNumber.length > 1
                              ? "accounts selected"
                              : "account selected"
                          }`
                    }
                    icon={
                      "https://q2pay.in/new_assets/common/view_all/close_with_blue_circle.svg"
                    }
                    enabledBgColor=""
                    outLineColor="var(--primary-act)"
                    disableIcon={true}
                    handleFunction={(e) => {
                      e.stopPropagation();
                      return;
                    }}
                    enabledTextColor="var(--text-primary)"
                  />
                ) : null}
                {selectedtBank.length ? (
                  <Chips
                    txtChip={selectedtBank}
                    icon={
                      "https://q2pay.in/new_assets/common/view_all/close_with_blue_circle.svg"
                    }
                    enabledBgColor=""
                    outLineColor="var(--primary-act)"
                    disableIcon={false}
                    handleFunction={() => {
                      setSelectedtBank("");
                      setSelectedtBankState("");
                    }}
                    hoverOption="white"
                    enabledTextColor="var(--text-primary)"
                  />
                ) : null}
                {amountLimit.min.length && amountLimit.max.length ? (
                  <Chips
                    txtChip={`INR ${FormatAmount({ price: amountLimit.min })} - INR ${FormatAmount({ price: amountLimit.max })}`}
                    icon={
                      "https://q2pay.in/new_assets/common/view_all/close_with_blue_circle.svg"
                    }
                    enabledBgColor=""
                    outLineColor="var(--primary-act)"
                    disableIcon={false}
                    handleFunction={() => {
                      setAmountLimit({ min: "", max: "" });
                      setAmountLimitState({ min: "", max: "" });
                      setIsAmtFilterApplied(false);
                    }}
                    hoverOption="white"
                    enabledTextColor="var(--text-primary)"
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            position:
              showCalendar || filterOpen || showAdditionalDetails
                ? "absolute"
                : "relative",
            opacity:
              showCalendar || filterOpen || showAdditionalDetails
                ? "var(--dark-opacity)"
                : "var(--opcacity_none)",
            display:
              showCalendar || filterOpen || showAdditionalDetails
                ? "block"
                : "hidden",
            backgroundColor:
              showCalendar || showAdditionalDetails || filterOpen
                ? "var(--PopUp-BackDrop)"
                : "",
            height:
              showCalendar || filterOpen || showAdditionalDetails
                ? "var(--height-full)"
                : "0",
            width:
              showCalendar || filterOpen || showAdditionalDetails
                ? "var(--width-full)"
                : "0",
            zIndex: "var(--z-index-content)",
          }}
        ></div>

        <div
          ref={scrollRef}
          style={{
            backgroundColor: "var(--primary-bg)",
            overflowY: "hidden",
            overflowX:
              ownerAllAccItemisedLoading ||
              !ownerAllAccItemisedData?.ecollection_callbacks?.length
                ? "hidden"
                : "scroll",
            borderRadius: "inherit",
            marginBottom: ownerAllAccItemisedData?.ecollection_callbacks?.length
              ? "var(--pagination-height)"
              : "",
            width:
              props?.popType == "ownerStatement"
                ? "var(--popup-width)"
                : "var(--full-width)",
          }}
          className={`${
            props?.popType == "ownerStatement"
              ? "popupstatementviewallscrolls"
              : ""
          } overflow-x-auto flex flex-col statementviewallscroll  flex-1`}
        >
          <div className="w-max min-w-full z-z-index-content ">
            <div
              className={`itemised-table-div-container ${
                showCalendar ? "" : " z-z-index-content"
              } mb-margin-xs pr-padding-sm`}
            >
              {additionalDetailCol?.map((column, index) => {
                return (
                  <>
                    <p
                      style={{
                        minWidth: `var(--${column.colWidth})`,
                        flex: `${column.flex}`,
                      }}
                      className={`text-font-xs px-padding-md h-auto py-padding-button-l text-text-secondary text-center`}
                    >
                      {column.colName}
                    </p>
                    <div
                      style={{
                        display:
                          index === additionalDetailCol.length - 1
                            ? "none"
                            : "block",
                      }}
                      className="itemised-border-mid-div"
                    ></div>
                  </>
                );
              })}
            </div>
          </div>

          {!accountNumber.length ? (
            <div className="h-height-full flex-col m-auto pb-padding-md  overflow-y-scroll justify-center items-center flex w-full">
              <img
                style={{
                  marginBottom: "var(--margin-xl)",
                  paddingTop: "var(--padding-xl)",
                }}
                src={ICONS?.VIEW_CATEGORY}
                alt="No accounts found"
                className="statement_noacc_found"
              />
              <p className="select_text flex flex-col">
                <span>Select account/s to</span>
                <span>view itemized statement</span>
              </p>
              <div>
                <PrimaryButton
                  enabledBgColor="var(--primary-act)"
                  btnText="Select account"
                  enabledTextColor="var(--text-primary)"
                  handleFunction={() => {
                    setShowOwnerPopup(true);
                  }}
                  buttonRef={selectAccountRef}
                  hoverOption="white"
                />
              </div>
            </div>
          ) : ownerAllAccItemisedLoading ? (
            <div
              className={`absolute top-auto overflow-x-auto flex h-height-lg m-auto justify-center items-center ${
                props?.popType === "ownerStatement"
                  ? "w-full-popup-width"
                  : "w-full-width"
              }`}
            >
              <Loader />
            </div>
          ) : ownerAllAccItemisedData?.ecollection_callbacks?.length ? (
            <div
              ref={scrollTopRef}
              style={{
                flex: "1",
                overflowY:
                  ownerAllAccItemisedLoading ||
                  ownerAllAccItemisedData?.owner_account_details?.statement
                    ?.length
                    ? "hidden"
                    : "auto",
              }}
              className={`${props?.popType === "ownerStatement" ? "" : "mb-margin-md"} overflow-y-scroll w-max min-w-full  mt-margin-base`}
            >
              {ownerAllAccItemisedData?.ecollection_callbacks?.map(
                (statement, index) => {
                  return (
                    <div
                      key={index}
                      className="itemised-table-div-content "
                    >
                      {additionalDetailCol.some(
                        (x) => x.colName === "Bank",
                      ) && (
                        <>
                          <div className="text-font-xs flex-0 pr-padding-md pl-padding-lg h-auto py-padding-xs  text-text-secondary text-center min-w-column-width-sm w-column-width-sm flex items-center">
                            <div className="py-padding-button-s px-padding-sm rounded-border-radius-md bg-text-primary flex justify-center items-center">
                              <div className="w-banklogo-width-sm h-banklogo-height-sm flex-shrink-0">
                                <IfscCodeMapper
                                  ifscCode={statement?.party_ifsc}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      {additionalDetailCol.some(
                        (x) => x.colName === "Transaction date",
                      ) && (
                        <>
                          <p
                            className={
                              "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md"
                            }
                          >
                            {statement?.transaction_date
                              ? formatDateandTime(
                                  statement?.transaction_date,
                                  true,
                                  true,
                                  true,
                                  true,
                                )
                              : "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailCol.some(
                        (x) => x.colName === "Value date",
                      ) && (
                        <>
                          <p
                            className={
                              "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md"
                            }
                          >
                            {statement?.value_date
                              ? formatDateandTime(statement?.value_date)
                              : "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailCol.some(
                        (x) => x.colName === "Party name",
                      ) && (
                        <>
                          <p className="text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-1 text-text-secondary text-center w-column-width-lg min-w-column-width-lg">
                            {statement?.party_name || "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailCol.some(
                        (x) => x.colName === "Amount",
                      ) && (
                        <>
                          <div
                            className={
                              " text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md"
                            }
                            style={{
                              color: "var(--settled)",
                              textAlign: "right",
                              justifyContent: "end",
                            }}
                          >
                            INR{" "}
                            <FormatAmount price={Number(statement?.amount)} />
                          </div>
                        </>
                      )}
                      {additionalDetailCol.some(
                        (x) => x.colName === "Narration",
                      ) && (
                        <>
                          <p
                            className={
                              "text-wrap  text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-1 text-text-secondary text-center w-column-width-lg min-w-column-width-lg"
                            }
                          >
                            {statement?.narration || "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailCol.some(
                        (x) => x.colName === "Bank reference",
                      ) && (
                        <>
                          <p
                            className={
                              "break-all text-wrap text-font-xs px-padding-md h-auto flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md"
                            }
                          >
                            {statement?.bank_reference || "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailCol.some(
                        (x) => x.colName === "Party account number",
                      ) && (
                        <>
                          <p
                            className={
                              "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md"
                            }
                          >
                            {statement?.party_account_number
                              ? formatAccountNumber(
                                  statement?.party_account_number,
                                )
                              : "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailCol.some(
                        (x) => x.colName === "Party IFSC",
                      ) && (
                        <>
                          <p className="text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md">
                            {statement?.party_ifsc || "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailCol.some(
                        (x) => x.colName === "Description",
                      ) && (
                        <div
                          className={
                            " px-padding-md h-auto flex items-center justify-center py-padding-xs flex-1 text-text-primary text-center w-column-width-lg min-w-column-width-lg"
                          }
                        >
                          {statement?.description?.length ? (
                            <div className="flex gap-x-gap-sm justify-center">
                              <p className="text-font-xs text-text-secondary break-all">
                                {linkIdentifier(statement?.description)}
                              </p>
                              <div className="border-r-border h-auto border-primary-act"></div>
                              <img
                                title="Edit"
                                src="https://q2pay.in/new_assets/common/create_flow/edit.svg"
                                alt="edit"
                                className={`h-icon-sm w-icon-sm flex-shrink-0 my-auto ${
                                  !services?.includes("ADescription") &&
                                  !services?.includes("Admin")
                                    ? "cursor-not-allowed opacity-light-opacity"
                                    : "cursor-pointer"
                                } `}
                                onClick={() => {
                                  if (
                                    !services?.includes("ADescription") &&
                                    !services?.includes("Admin")
                                  ) {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService:
                                          "VAccountBalance,Admin",
                                      },
                                    });
                                  } else {
                                    setIsEditDescription(true);
                                    setDescription(statement?.description);
                                    setCurrentDescription({
                                      acc_id: statement?.owner_account_id,

                                      description: statement?.description,
                                      ecollection_callback_id:
                                        statement?.ecollection_callback_id,
                                    });
                                    setShowDescriptionPopup(true);
                                  }
                                }}
                              />
                            </div>
                          ) : (
                            <PrimaryWithIconButton
                              btnText="Add description"
                              outLineColor={"var(--text-primary)"}
                              btnType="button"
                              enabledBgColor="transparent"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                              iconToBeAlign="left"
                              icon="https://q2pay.in/new_assets/common/settings/add_button_white.svg"
                              imgColor="var(--text-primary)"
                              isDisabled={
                                !services?.includes("ADescription") &&
                                !services?.includes("Admin")
                              }
                              handleFunction={() => {
                                if (
                                  !services?.includes("ADescription") &&
                                  !services?.includes("Admin")
                                ) {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService:
                                        "VAccountBalance,Admin",
                                    },
                                  });
                                } else {
                                  setIsEditDescription(false);
                                  setShowDescriptionPopup(true);
                                  setCurrentDescription({
                                    acc_id: statement?.owner_account_id,

                                    description: statement?.description,
                                    ecollection_callback_id:
                                      statement?.ecollection_callback_id,
                                  });
                                }
                              }}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  );
                },
              )}
            </div>
          ) : (
            <div
              className={`h-height-full flex-col m-auto  ${
                props?.popType === "ownerStatement"
                  ? "w-full-popup-width"
                  : "w-full-width"
              }  overflow-y-scroll justify-center items-center flex`}
            >
              <img
                src={
                  "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                }
                alt="No accounts found"
                className="w-graphic-width-lg h-graphic-rectangle-height-lg "
              />
              <p className="text-text-primary text-font-sm pt-padding-sm items-center">
                No data found.
              </p>
              <div
                style={{
                  display:
                    accountNumber.length !== accountDefaultNumber.length ||
                    !accountDefaultNumber.every((ac) => {
                      return accountNumber.includes(ac);
                    }) ||
                    (new Date(startDate).setHours(0, 0, 0, 0) !==
                      new Date(new Date().setDate(1)).setHours(0, 0, 0, 0) &&
                      new Date(endDate).setHours(0, 0, 0, 0) !==
                        new Date().setHours(0, 0, 0, 0)) ||
                    selectedtBank.length ||
                    (amountLimit.min.length && amountLimit.max.length)
                      ? "flex justify-center"
                      : "none",
                  paddingTop: "var(--padding-sm)",
                }}
              >
                <PrimaryButton
                  isDisabled={
                    filterOpen || showAdditionalDetails || showCalendar
                  }
                  enabledBgColor="var(--primary-act)"
                  btnText="Clear parameters"
                  enabledTextColor="var(--text-primary)"
                  handleFunction={() => {
                    move();
                    setAccountNumber(accountDefaultNumber);
                    setaccountnumberstate(accountDefaultNumber);
                    setSelectedtBank("");
                    setSelectedtBankState("");
                    setAmountLimit({ min: "", max: "" });
                    setAmountLimitState({ min: "", max: "" });

                    setIsAmtFilterApplied(false);
                    setStartDate(new Date(new Date().setDate(1)));
                    setStartDateState(new Date(new Date().setDate(1)));
                    setEndDate(new Date());
                    setEndDateState(new Date());
                    setIsDateConfirm(false);
                    setCurrentPage(1);
                  }}
                  buttonRef={selectAccountRef}
                  hoverOption="white"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ItemisedReportComponent;
